module.exports = __webpack_public_path__ + "components/roadsurfer/static/roadsurfer-1600@2x-43a5acbf416e8af93814cbfae77248ed.webp";